import { useOfferCargoSubscriptionManagement } from "./fetch";
import { OfferCargoSubscriptionManagementUi } from "./ui";

export type { OfferCargoSubscriptionManagementProps } from "./model";

export const OfferCargoSubscriptionManagement = (params: {
  companyId: number;
}) => {
  const props = useOfferCargoSubscriptionManagement(params.companyId);
  return <OfferCargoSubscriptionManagementUi {...props} />;
};
